import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CountryRestrictionService } from '@app/country-restriction/country-restriction.service';
import * as Mousetrap from 'mousetrap';
import * as amplitude from 'amplitude-js';

// tslint:disable:max-line-length
@Component({
  selector: 'app-country-restriction',
  styles: [
    `
      :host {
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 9999;
      }

      ._20-px-spacer {
        width: 20px;
        height: 20px;
        flex: 0 0 auto;
      }

      p {
        margin-bottom: 20px;
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        line-height: 24px;
      }

      .icon.region-icons {
        border-radius: 4px;
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-bottom: 20px;
        background-color: #283753;
        font-size: 16px;
        line-height: 40px;
      }

      h2._10-px-margin {
        margin-bottom: 10px;
        text-align: center;
        color: #fff;
      }

      .content {
        position: relative;
        z-index: 2;
        width: 800px;
        padding: 180px 40px 20px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px;
        background-color: #172135;
        color: #fff;
        text-align: left;
        overflow: auto;
      }

      @media (max-width: 800px) {
        .content {
          width: 100%;
        }
      }

      @media (max-width: 800px) {
        .restricted-row {
          flex-direction: column;
        }
      }

      .paragraph {
        text-align: center;
        margin-bottom: 20px;
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        line-height: 24px;
      }

      .restricted-world-image {
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        height: 200px;
        background-image: url('/assets/images/world.svg');
        background-position: 50% 100%;
        background-size: cover;
      }

      .restricted-row {
        position: relative;
        z-index: 2;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        align-items: stretch;
      }

      .restricted-column {
        margin-bottom: 0px;
        padding-right: 10px;
        padding-bottom: 20px;
        padding-left: 10px;
        -webkit-box-flex: 0;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        text-align: center;
      }

      .contact-us-link {
        transition: opacity 200ms ease;
        color: #3ecf8e;
        font-size: 16px;
      }

      .logo-container {
        width: 200px;
      }

      h1 {
        margin-top: 25px;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
        font-weight: 300;
      }
    `,
  ],
  template: `
    <div class="content">
      <div class="restricted-region-column">
        <h2 translate class="_10-px-margin">Welcome to Edgeless</h2>
        <p class="paragraph">
          Unfortunately, you have logged in from restricted country.<br />
          Edgeless is currently not available in {{ countryRestrictionService.userCountry || 'Dark Web' }}.
        </p>
        <div class="_20-px-spacer"></div>
        <div class="restricted-row">
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-newspaper"></span></div>
            <h5 translate class="heading-4">About Edgeless</h5>
            <p translate>
              Edgeless is one of a few blockchain companies that has a product for mass consumer.
              <a
                href="https://edgelessgroup.io/?utm_source=casino&utm_medium=restricted-countries"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country - Link to edgelessgroup')"
                >More info</a
              >
            </p>
          </div>
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-chart-line"></span></div>
            <h5 translate class="heading-3">country_restriction.staking</h5>
            <p translate>
              country_restriction.staking_info<a
                href="https://staking.edgelessgroup.io/?utm_source=casino&utm_medium=restricted-countries"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country - Link to staking')"
                >country_restriction.staking_more_info</a
              >
            </p>
          </div>
        </div>
        <div class="restricted-row">
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-globe"></span></div>
            <h5 translate class="heading">country_restriction.bypass</h5>
            <p translate>country_restriction.bypass_info</p>
          </div>
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-question"></span></div>
            <h5 class="heading-2" translate>country_restriction.need_help</h5>
            <p translate>
              Let's make this gambling experience the best in the industry!
              <a
                href="mailto:support@edgeless.io"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country - Email to support')"
                >support@edgeless.io</a
              >
            </p>
          </div>
        </div>
        <div class="restricted-world-image" (click)="clicker($event)"></div>
      </div>
    </div>
  `,
})
export class CountryRestrictionComponent implements OnInit, OnDestroy {
  private keyword = ['a l l o w', 'h a c k'];
  private clicks: number = 0;
  private timeout: any = null;

  constructor(public countryRestrictionService: CountryRestrictionService, private renderer: Renderer2) {}

  ngOnInit() {
    amplitude.getInstance().logEvent('Restricted Country - Init');
    this.clicks = 0;
    Mousetrap.bind(this.keyword, () => {
      this.countryRestrictionService.allowUser();
      try {
        this.renderer.removeClass(document.getElementsByTagName('html')[0], 'restricted');
      } catch (e) {
        //
      }
    });
    try {
      this.renderer.addClass(document.getElementsByTagName('html')[0], 'restricted');
    } catch (e) {
      //
    }
  }

  ngOnDestroy() {
    Mousetrap.unbind(this.keyword);
    this.clearTimeout();
  }

  public clicker($event: Event): void {
    $event.preventDefault();
    this.clicks++;
    this.clearTimeout();
    if (this.clicks === 6) {
      this.countryRestrictionService.allowUser();
      try {
        this.renderer.removeClass(document.getElementsByTagName('html')[0], 'restricted');
      } catch (e) {
        //
      }
    } else {
      this.timeout = setTimeout(() => {
        this.clicks = 0;
      }, 300);
    }
  }

  public logEvent(event: string): void {
    amplitude.getInstance().logEvent(event);
  }

  private clearTimeout(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/country-restriction/country-restriction.component.ts